import { useQueryClient } from "react-query";

export default function useForgotPasswordLogic() {
  const queryClient = useQueryClient().getQueryData("reset");

  return {
    email: queryClient?.data?.data || "undefined",
  };
}
